const paymentTypes = {
    START_CREATE_PAYMENT_TOKEN: 'START_CREATE_PAYMENT_TOKEN',
    CREATE_PAYMENT_TOKEN_SUCCESS: 'CREATE_PAYMENT_TOKEN_SUCCESS',
    CREATE_PAYMENT_TOKEN_FAILURE: 'CREATE_PAYMENT_TOKEN_FAILURE',

    START_CREATE_USER_PAYMENT: 'START_CREATE_USER_PAYMENT',
    CREATE_USER_PAYMENT_SUCCESS: 'CREATE_USER_PAYMENT_SUCCESS',
    CREATE_USER_PAYMENT_FAILURE: 'CREATE_USER_PAYMENT_FAILURE',

    START_GET_USER_PAYMENT: 'START_GET_USER_PAYMENT',
    GET_USER_PAYMENT_SUCCESS: 'GET_USER_PAYMENT_SUCCESS',
    GET_USER_PAYMENT_FAILURE: 'GET_USER_PAYMENT_FAILURE',

    START_UPDATE_USER_PAYMENT: 'START_UPDATE_USER_PAYMENT',
    UPDATE_USER_PAYMENT_SUCCESS: 'UPDATE_USER_PAYMENT_SUCCESS',
    UPDATE_USER_PAYMENT_FAILURE: 'UPDATE_USER_PAYMENT_FAILURE',

    START_DELETE_USER_PAYMENT: 'START_DELETE_USER_PAYMENT',
    DELETE_USER_PAYMENT_SUCCESS: 'DELETE_USER_PAYMENT_SUCCESS',
    DELETE_USER_PAYMENT_FAILURE: 'DELETE_USER_PAYMENT_FAILURE',

    START_CREATE_PAYMENT_LANDING_PAGE: 'START_CREATE_PAYMENT_LANDING_PAGE',
    CREATE_PAYMENT_LANDING_PAGE_SUCCESS: 'CREATE_PAYMENT_LANDING_PAGE_SUCCESS',
    CREATE_PAYMENT_LANDING_PAGE_FAILURE: 'CREATE_PAYMENT_LANDING_PAGE_FAILURE'
};

export default paymentTypes;